// src/components/store/sections/testimonials/TestimonialV63BentoreviewsSlateGold.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV63BentoreviewsSlateGold(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={63}
      archKey="bento_reviews"
      archLabel="Bento Review Matrix"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
